// Filtros da gestão de usuários. A base é pequena e a listagem já chega inteira do
// backend, então o filtro roda no navegador (resposta instantânea, sem nova consulta).
// Valor vazio = filtro desligado.
export const EMPTY_FILTERS = {
  query: "",
  plan: "",
  status: "", // ativo | inativo
  role: "",
  verified: "", // sim | nao
};

// "José Antônio" e "jose antonio" precisam se encontrar.
const normalize = (text) =>
  (text ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

const matchesQuery = (user, query) => {
  const term = normalize(query);
  return !term || normalize(user.email).includes(term) || normalize(user.nome).includes(term);
};

const matchesStatus = (user, status) => !status || (status === "ativo") === user.ativo;

const matchesVerified = (user, verified) => !verified || (verified === "sim") === user.is_email_verified;

export function filterUsers(users, filters) {
  return users.filter(
    (user) =>
      matchesQuery(user, filters.query) &&
      (!filters.plan || user.plan === filters.plan) &&
      matchesStatus(user, filters.status) &&
      (!filters.role || user.role === filters.role) &&
      matchesVerified(user, filters.verified),
  );
}
